const state = () => ({
    modelRegi: null,
    faqRegi: null,
    noticeRegi: null,
    postRegi: null,
    category: null,
    banner: null,
    parts: null,
    userRegi: null,
    gptBannerRegi: null,
});

const getters = {
    getModelRegi: (state) => state.modelRegi,
    getFaqRegi: (state) => state.faqRegi,
    getNoticeRegi: (state) => state.noticeRegi,
    getPostRegi: (state) => state.postRegi,
    getCategory: (state) => state.category,
    getBanner: (state) => state.banner,
    getParts: (state) => state.parts,
    getUserRegi:(state) => state.userRegi,
    getGptBannerRegi:(state) => state.gptBannerRegi,
};

const actions = {
    setModelRegi({ commit }, result) {
        commit('SET_MODEL_REGI', result);
    },
    clearModelRegi({ commit }) {
        commit('CLEAR_MODEL_REGI');
    },
    setFaqRegi({ commit }, result) {
        commit('SET_FAQ_REGI', result);
    },
    clearFaqRegi({ commit }) {
        commit('CLEAR_FAQ_REGI');
    },
    setNoticeRegi({ commit }, result) {
        commit('SET_NOTICE_REGI', result);
    },
    clearNoticeRegi({ commit }) {
        commit('CLEAR_NOTICE_REGI');
    },
    setPostRegi({ commit }, result) {
        commit('SET_POST_REGI', result);
    },
    clearPostRegi({ commit }) {
        commit('CLEAR_POST_REGI');
    },
    clearRegiTemp({ commit }) {
        commit('CLEAR_REGI_TEMP');
    },
    setCategory({ commit }, result) {
        commit('SET_CATEGORY', result);
    },
    clearCategory({ commit }) {
        commit('CLEAR_CATEGORY');
    },
    setBanner({ commit }, result) {
        commit('SET_BANNER', result);
    },
    clearBanner({ commit }) {
        commit('CLEAR_BANNER');
    },
    setParts({ commit }, result) {
        commit('SET_PARTS', result);
    },
    clearParts({ commit }) {
        commit('CLEAR_PARTS');
    },
    setUserRegi({ commit }, result) {
        commit('SET_USER_REGI', result);
    },
    clearUserRegi({ commit }) {
        commit('CLEAR_USER_REGI');
    },
    setGptBannerRegi({ commit }, result) {
        commit('SET_GPTBANNER_REGI', result);
    },
    clearGptBannerRegi({ commit }) {
        commit('CLEAR_GPTBANNER_REGI');
    },
    
};

const mutations = {
    SET_MODEL_REGI(state, result) {
        state.modelRegi = result;
    },
    CLEAR_MODEL_REGI(state) {
        state.modelRegi = null;
    },
    SET_FAQ_REGI(state, result) {
        state.faqRegi = result;
    },
    CLEAR_FAQ_REGI(state) {
        state.faqRegi = null;
    },
    SET_NOTICE_REGI(state, result) {
        state.noticeRegi = result;
    },
    CLEAR_NOTICE_REGI(state) {
        state.noticeRegi = null;
    },
    SET_POST_REGI(state, result) {
        state.postRegi = result;
    },
    CLEAR_POST_REGI(state) {
        state.postRegi = null;
    },
    SET_CATEGORY(state, result) {
        state.category = result;
    },
    CLEAR_CATEGORY(state) {
        state.category = null;
    },
    SET_BANNER(state, result) {
        state.banner = result;
    },
    CLEAR_BANNER(state) {
        state.banner = null;
    },
    SET_PARTS(state, result) {
        state.parts = result;
    },
    CLEAR_PARTS(state) {
        state.parts = null;
    },
    SET_USER_REGI(state, result) {
        state.userRegi = result;
    },
    CLEAR_USER_REGI(state) {
        state.userRegi = null;
    },
    SET_GPTBANNER_REGI(state, result) {
        state.gptBannerRegi = result;
    },
    CLEAR_GPTBANNER_REGI(state) {
        state.gptBannerRegi = null;
    },
    CLEAR_REGI_TEMP(state) {
        state.modelRegi = null;
        state.faqRegi = null;
        state.noticeRegi = null;
        state.postRegi = null;
        state.parts = null;
        state.banner = null;
        state.category = null;
        state.userRegi = null;
        state.gptBannerRegi = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
